import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  PersonIdentifierCreateCommand,
  PersonIdentifierUpdateCommand,
  PersonIdentifierVerificationFilter,
  PersonIdentifierViewModel
} from '../models/Entities/Person/Identifier/PersonIdentifierModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

// Get all identifiers of a person
export const GetIdentifiersByPersonId = async (
  token: string,
  personId: number
): Promise<PersonIdentifierViewModel[]> => {
  const requestUrl: string = buildURL(BaseURL, personId, 'identifiers');
  return apiRequest<PersonIdentifierViewModel[]>(requestUrl, token, 'GetIdentifiersByPersonId');
};

// Get person identifier by id
export const GetPersonIdentifierById = async (
  token: string,
  personIdentifierId: number
): Promise<PersonIdentifierViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'identifiers', personIdentifierId);
  return apiRequest<PersonIdentifierViewModel>(requestUrl, token, 'GetPersonIdentifierById');
};

// Verify that an identifier is available
export const VerifyIdentifier = async (
  token: string,
  filter: PersonIdentifierVerificationFilter
): Promise<boolean> => {
  const parameters = new URLSearchParams();
  parameters.append('identifierTypeId', String(filter.identifierTypeId));
  parameters.append('identifier', filter.identifier);
  if (filter.personId !== undefined && filter.personId !== null)
    parameters.append('personId', String(filter.personId));

  const requestUrl: string = `${buildURL(BaseURL, 'identifiers', 'verification')}?${parameters.toString()}`;
  return apiRequest<boolean>(requestUrl, token, 'VerifyIdentifier');
};

// Create person identifier
export const CreatePersonIdentifier = async (
  token: string,
  payload: PersonIdentifierCreateCommand
): Promise<PersonIdentifierViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'identifiers');
  return apiRequest<PersonIdentifierViewModel>(requestUrl, token, 'CreatePersonIdentifier', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update person identifier
export const UpdatePersonIdentifier = async (
  token: string,
  payload: PersonIdentifierUpdateCommand
): Promise<PersonIdentifierViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'identifiers');
  return apiRequest<PersonIdentifierViewModel>(requestUrl, token, 'UpdatePersonIdentifier', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete person identifier
export const DeletePersonIdentifier = async (
  token: string,
  personIdentifierId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, 'identifiers', personIdentifierId);
  return apiRequest<number>(requestUrl, token, 'DeletePersonIdentifier', {
    method: 'DELETE'
  });
};
